export const tests = [
    {
        key: 'physical',
        number: '01',
        header: 'Тип отдыха · 01',
        title: 'Физический',
        subtitle: 'отдых',
        description: 'Ответьте на каждый вопрос, выбрав вариант, который лучше всего описывает вас.',
        resulLink: 'https://t.me/frankl_logotherapy/103',
        resultDescription: (
            <>
                Ваше тело требует покоя или, наоборот, мягкой активности,
                если вы долго находились в статичном положении. Восстанавливайтесь
                через пассивный (сон, дневной сон) и активный отдых (растяжка,
                массаж, йога, техники релаксации), чтобы снять напряжение и усталость.
            </>
        ),

        questions: [
            'Если бы у меня был лишний час, чтобы закончить список дел или поспать, я бы выбрал(а) сон',
            'В конце дня я чувствую усталость, и мне трудно заснуть',
            'Я чаще других болею простудами и другими инфекциями верхних дыхательных путей',
            'У меня ежедневно болят мышцы, тело и шея',
            'С 14:00 до 17:00 я часто чувствую упадок сил и тянусь к сладкому или кофе',
            'По вечерам я обычно пью вино или алкоголь, чтобы расслабиться',
            'Иногда мне приходится поднимать в течение дня тяжести весом от 9 кг и больше',
            'Я занимаюсь более 5 часов в неделю интенсивными тренировками или регулярно играю в спортивные игры',
            'У меня часто не хватает энергии, чтобы заниматься чем-то приятным с семьёй в будни или на выходных',
            'Я сплю меньше 6 часов в сутки'
        ]
    },

    {
        key: 'mental',
        number: '02',
        header: 'Тип отдыха · 02',
        title: 'Ментальный',
        subtitle: 'отдых',
        description: 'Ответьте на каждый вопрос, выбрав вариант, который лучше всего описывает вас.',
        resultDescription: (
            <>
                <a href="https://t.me/frankl_logotherapy/205" target="_blank" rel="noreferrer">
                    Почему вы устали и как отдыхать правильно
                </a>
            </>
        ),

        questions: [
            'Мне трудно сосредоточиться, мысли часто «уплывают»',
            'Меня раздражает и злит, когда кто-то добавляет задачи в мой список дел',
            'Я избегаю новых задач, потому что боюсь сделать ошибку или всё испортить',
            'Мне трудно принимать решения',
            'Я часто срываюсь и злюсь на близких из-за пустяков',
            'Большую часть дня я делаю то, что вызывает у меня чувство перегрузки',
            'Мне проще мечтать о жизни, которую я хочу, чем разбираться со своей реальной жизнью',
            'Я часто не могу уснуть, прокручивая в голове события и разговоры дня',
            'Я забывчив(а), и мне трудно запоминать новое',
            'Мне сложно осваивать новые идеи и способы делать что-то'
        ]
    },

    {
        key: 'emotional',
        number: '03',
        header: 'Тип отдыха · 03',
        title: 'Эмоциональный',
        subtitle: 'отдых',
        description: 'Ответьте на каждый вопрос, выбрав вариант, который лучше всего описывает вас.',
        resultDescription: (
            <>
                <a href="https://t.me/frankl_logotherapy/201" target="_blank" rel="noreferrer">
                    Почему вы устали и как отдыхать правильно
                </a>
            </>
        ),

        questions: [
            'Я чаще думаю о своих неудачах и недостатках, чем о достижениях',
            'Я чувствую неуверенность в себе среди новых людей или в новых ситуациях',
            'Я часто извиняюсь, даже если не виноват(а)',
            'Я самый строгий критик самому себе',
            'Мне бывает грустно или я злюсь, когда думаю о том, куда движется моя жизнь',
            'Я тревожусь, когда слышу новости или думаю о возможных опасностях вокруг',
            'Я скорее пессимистичен(на), чем оптимистичен(на) в отношении жизни',
            'Мне важно объяснять свои действия, даже если это не требуется',
            'Большую часть рабочего дня я стараюсь выглядеть «лучшей версией себя» для клиентов, коллег или заказчиков',
            'Мне неловко говорить о своих желаниях и целях'
        ]
    },

    {
        key: 'sensory',
        number: '04',
        header: 'Тип отдыха · 04',
        title: 'Сенсорный',
        subtitle: 'отдых',
        description: 'Ответьте на каждый вопрос, выбрав вариант, который лучше всего описывает вас.',
        resultDescription: (
            <>
                <a href="https://t.me/frankl_logotherapy/217" target="_blank" rel="noreferrer">
                    Почему вы устали и как отдыхать правильно
                </a>
            </>
        ),

        questions: [
            'Я чувствителен(льна) к громким звукам и яркому свету',
            'Я провожу за экраном компьютера больше 4 часов в день',
            'Мне не нравятся натуральные продукты — они кажутся безвкусными',
            'Мне не нравится, когда меня обнимают',
            'Я плохо различаю запахи, которые другие чувствуют легко',
            'Мне не нравятся концерты, фейерверки и другие места с избытком звуков и впечатлений',
            'Я часто хочу есть обработанную пищу (фастфуд, колбасы) и сладкие напитки',
            'К концу дня у меня болят глаза, чувствуется давление или усталость за ними',
            'У меня нет сексуального влечения, и мне не нравится, когда меня трогают',
            'Я тревожусь, когда вокруг слишком много движения или активности'
        ]
    },

    {
        key: 'creative',
        number: '05',
        header: 'Тип отдыха · 05',
        title: 'Творческий',
        subtitle: 'отдых',
        description: 'Ответьте на каждый вопрос, выбрав вариант, который лучше всего описывает вас.',
        resultDescription: (
            <>
                <a href="https://t.me/frankl_logotherapy/254" target="_blank" rel="noreferrer">
                    Почему вы устали и как отдыхать правильно
                </a>
            </>
        ),

        questions: [
            'Я сосредотачиваюсь на нуждах семьи и ставлю их выше своих',
            'Я часто исключаю заботу о себе из списка дел',
            'Мне кажется эгоистичным делать что-то только для себя',
            'Я совершаю поступки, которые вредят мне или мешают моему счастью',
            'Я не верю, что моя работа имеет ценность или что другие её ценят',
            'Я живу в городе',
            'Мне трудно придумывать новые идеи',
            'Я почти всё время провожу в помещении и редко бываю на природе',
            'Я не считаю себя творческим человеком',
            'Мне не хватает мотивации и вдохновения'
        ]
    },

    {
        key: 'social',
        number: '06',
        header: 'Тип отдыха · 06',
        title: 'Социальный',
        subtitle: 'отдых',
        description: 'Ответьте на каждый вопрос, выбрав вариант, который лучше всего описывает вас.',
        resultDescription: (
            <>
                <a href="https://t.me/frankl_logotherapy/218" target="_blank" rel="noreferrer">
                    Почему вы устали и как отдыхать правильно
                </a>
            </>
        ),

        questions: [
            'Я избегаю социальных ситуаций',
            'Я часто чувствую отстранённость от семьи и друзей',
            'Я притягиваю людей, которые плохо со мной обращаются или проявляют насилие',
            'Мне трудно поддерживать близкие отношения и заводить друзей',
            'Мне кажется, что только я один(одна) сталкиваюсь с трудностями в жизни',
            'Я предпочитаю онлайн-общение живому',
            'Мне нравится работать над проектами в одиночку',
            'Мой образ в соцсетях не отражает мою реальную жизнь',
            'Я изолируюсь от других и предпочитаю быть один(одна)',
            'Если бы сегодня мне понадобилась помощь, я не знаю, кому бы позвонил(а)'
        ]
    },

    {
        key: 'spiritual',
        number: '07',
        header: 'Тип отдыха · 07',
        title: 'Духовный',
        subtitle: 'отдых',
        description: 'Ответьте на каждый вопрос, выбрав вариант, который лучше всего описывает вас.',
        resultDescription: (
            <>
                Вернуть ощущение смысла можно через то, что мы даем миру,
                через то, что мы берем от мира, и через отношение к тому,
                что мы не можем изменить. Подробнее в канале{' '}
                <a href="https://t.me/frankl_logotherapy/103" target="_blank" rel="noreferrer">
                    «Человек в поисках смысла»
                </a>
            </>
        ),
        questions: [
            'Мне кажется, что жизнь бессмысленна и не имеет настоящей цели',
            'Я не испытываю чувства удовлетворения от своей работы или жизни в целом',
            'Я часто чувствую себя беспомощным(ой), безнадёжным(ой), в ловушке или побеждённым(ой)',
            'У меня бывали мысли о самоубийстве',
            'Я не верю, что Бог заботится обо мне лично',
            'Иногда я чувствую онемение и причиняю себе боль, чтобы хоть что-то почувствовать',
            'Я не удовлетворён(а) своей жизнью',
            'Я нахожу утешение в еде, наркотиках или алкоголе',
            'Иногда я жалею, что родился(ась)',
            'Мне трудно понять или принять концепцию Бога'
        ]
    }
];

export const answers = [
    [0, 'Не про меня'],
    [1, 'Редко'],
    [2, 'Иногда'],
    [3, 'Часто'],
    [4, 'Почти всегда']
];